module.exports = __webpack_public_path__ + "static/img/Steve-Menzies.10374a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steve-Menzies.jpg
// module id = UdYk
// module chunks = 0